const availiableProducts = Object.freeze({
  utilizacaoCartooDebito: 'Cartão Débito',
  utilizacaoCartaoCredito: 'Cartão Crédito',
  utilizacaoPrevidencia: 'Previdência',
  indicadorUtilizacaoSipag: 'Sipag',
  debitoAutomaticoEfetivado: 'Débito Automatico Efetivado',
  produtoRdc: 'RDC',
  produtoChequeEspecialContaGarantida: 'Cheque Especial Conta Garantida',
  produtoContaGarantida: 'Conta Garantida',
  produtoChequeEspecial: 'Cheque Especial',
  produtoCobranca: 'Cobrança',
  produtoConsorcioAutomovel: 'Consórcio Automóvel',
  produtoConsorcioImovel: 'Consórcio Imóvel',
  produtoConsorcioMoto: 'Consórcio Moto',
  produtoConsorcioServicos: 'Consórcio Serviços',
  produtoPreAprovado: 'Pré-Aprovado',
  produtoCreditoRural: 'Crédito Rural',
  produtoEmprestimo: 'Empréstimo',
  produtoFinanciamento: 'Financiamento',
  produtoPoupanca: 'Poupança',
  produtoSeguroRural: 'Seguro Rural',
  produtoSeguroAuto: 'Seguro Auto',
  produtoVidaPrestamista: 'Vida Prestamista',
  produtoSeguroVidaPfPj: 'Seguro Vida PF/PJ',
  produtoSeguroMassificados: 'Seguro Massificados',
  produtoTituloDescontado: 'Título Descontado',
  indicadorProdutoCambio: 'Câmbio',
  indicadorProdutoConsorcioBensMoveis: 'Consórcio Bens Móveis',
  indicadorProdutoConsorcioPesado: 'Consórcio Pesado',
  indicadorProdutoCoopcerto: 'Coopcerto',
  indicadorProdutoLCI: 'LCI',
  indicadorProdutoLCA: 'LCA',
  indicadorProdutoVGBL: 'VGBL',
  indicadorProdutoPix: 'Pix',
  indicadorProdutoTag: 'Tag',
  indicadorProdutoSeguroPatrimonial: 'Seguro Patrimonial',
  indicadorProdutoSeguroRiscoFinanceiro: 'Seguro Risco Financeiro',
  indicadorProdutoFundoInvestimento: 'Fundo de Investimento'
})
export default availiableProducts



// WEBPACK FOOTER //
// ./src/enums/iapProducts.js